import { t, type MessageKey } from '../../i18n';
import { Glyph } from '../components/Glyph';
import { SymbolLegend } from '../components/SymbolLegend';

const SECTIONS = [
  'goal',
  'board',
  'cards',
  'matching',
  'turn',
  'score',
  'wild',
  'epitaph',
  'variants',
  'campaign',
  'symbols',
  'controls',
] as const;

function Body({ text }: { text: string }) {
  const blocks = text.split('\n\n');
  return (
    <>
      {blocks.map((block, i) =>
        block.startsWith('•') ? (
          <ul key={i}>
            {block.split('\n').map((line, j) => (
              <li key={j}>{line.replace(/^•\s*/, '')}</li>
            ))}
          </ul>
        ) : (
          <p key={i}>{block}</p>
        ),
      )}
    </>
  );
}

export function RulesScreen({
  onBack,
  onTutorial,
}: {
  onBack: () => void;
  /** Opens the interactive tutorial. */
  onTutorial?: () => void;
}) {
  return (
    <main className="page page-rules">
      <header className="page-head">
        <button type="button" className="btn btn-small" onClick={onBack}>
          ← {t('menu.back')}
        </button>
        <h1>{t('rules.title')}</h1>
      </header>
      <p className="lead">{t('rules.intro')}</p>
      {onTutorial && (
        <p className="rules-tutorial">
          {t('rules.tutorial')}{' '}
          <button type="button" className="btn btn-small" onClick={onTutorial}>
            {t('menu.tutorial')}
          </button>
        </p>
      )}
      <div className="glyph-legend" aria-hidden="true">
        {(['R', 'B', 'G', 'Y'] as const).map((c) => (
          <span key={c} className={`legend-item c-${c}`}>
            <Glyph color={c} size={22} />
            <span>
              {t(`color.${c}`)}: {t(`color.${c}.move`)}
            </span>
          </span>
        ))}
      </div>
      <nav className="rules-toc" aria-label={t('rules.title')}>
        {SECTIONS.map((s) => (
          <a key={s} href={`#rules-${s}`}>
            {t(`rules.${s}.title` as MessageKey)}
          </a>
        ))}
      </nav>
      {SECTIONS.map((s) => (
        <section key={s} id={`rules-${s}`} className="rules-section">
          <h2>{t(`rules.${s}.title` as MessageKey)}</h2>
          {s === 'symbols' ? <SymbolLegend /> : <Body text={t(`rules.${s}.body` as MessageKey)} />}
        </section>
      ))}
    </main>
  );
}
